import React from 'react'
import { Link } from "react-router-dom"
import Navbar from "../components/Navbar"
import Footer from "../components/Footer"

const NoPage = () => {
  return (
    <>
      <Navbar />
      <main className="flex min-h-[70vh] flex-col items-center justify-center gap-4 px-6 pt-32 text-center">
        <span className="font-mono text-sm uppercase tracking-widest text-signal-400">{"// error"}</span>
        <h1 className="text-5xl font-semibold text-mist-100">404</h1>
        <p className="text-mist-500">This route doesn't exist.</p>
        <Link to="/" className="hover-underline font-mono text-signal-400">Back home</Link>
      </main>
      <Footer />
    </>
  );
};

export default NoPage;
